export enum VisitTypeEnum {
  InPerson = 1,
  Telephonic = 2,
  Virtual = 3
}

export const VisitTypeOptions = [
{ id: 1, label: 'In Person' },
{ id: 2, label: 'Telephonic' },
{ id: 3, label: 'Virtual' }
];
